module.exports = __webpack_public_path__ + "static/media/logo-icon.f61a739f.png";